import { GoogleMapsAPIWrapper } from 'angular2-google-maps/core';
import { Directive, Input, Output, EventEmitter } from '@angular/core';

declare var google: any;

@Directive({
  selector: 'sebm-google-map-directions'
})
export class DirectionsMapDirective {
  public temps: any; 
  @Input() origin: any;
  @Input() destination: any;
  @Input() waypoints: any;
  @Input() directionsDisplay: any;
  @Input() estimatedTime: any;
  @Input() estimatedDistance: any;
  @Input () metode: string;

  @Output() sendTemps = new EventEmitter();

  constructor(private gmapsApi: GoogleMapsAPIWrapper) { }
  updateDirections() {
    return this.gmapsApi.getNativeMap().then(map => {

      var directionsService = new google.maps.DirectionsService;
      var me = this;
      this.directionsDisplay.setMap(map);
      this.directionsDisplay.setOptions({
        polylineOptions: {
          strokeWeight: 8,
          strokeOpacity: 0.7,
          strokeColor: '#00468c'
        }
      });
      this.directionsDisplay.setDirections({ routes: [] });

      let travelMode;
      if(this.metode === "WALKING"){
          travelMode = google.maps.DirectionsTravelMode.WALKING
        }else if(this.metode === "DRIVING"){
          travelMode = google.maps.DirectionsTravelMode.DRIVING
        }

      directionsService.route({
        origin: { lat: this.origin.latitude, lng: this.origin.longitude },
        destination: { lat: this.destination.latitude, lng: this.destination.longitude },
        avoidHighways: true,
        travelMode: travelMode

        //travelMode: 'DRIVING'
      }, (response: any, status: any) => {
        if (status === 'OK') {
          me.directionsDisplay.setDirections(response);
          me.directionsDisplay.setOptions( { suppressMarkers: true } );
          map.setZoom(30);
          //console.log(me.getcomputeDistance (latLngA, latLngB));
          var point = response.routes[0].legs[0];
          me.estimatedTime = point.duration.text;
          me.estimatedDistance = point.distance.text;
          this.temps = point.duration.text;
          this.enviaTemps();
        } else {
          console.log('Directions request failed due to ' + status);
        }
      });
    });

  }

  public enviaTemps() {
      this.sendTemps.emit({
        value: this.temps,
        method: this.metode
    });
  }
}


// WEBPACK FOOTER //
// ./src/map/google-map.directive.ts